import { supabase } from '../lib/supabase';

export interface ProductUpdateInfo {
  id: string;
  updated_at: string;
  is_active: boolean;
}

export class ProductUpdateService {
  /**
   * Check if a product has been updated by comparing updated_at timestamps
   * This is a lightweight query that only fetches the minimal data needed
   */
  static async checkProductUpdate(productId: string): Promise<ProductUpdateInfo | null> {
    try {
      const { data, error } = await supabase
        .from('products')
        .select('id, updated_at, is_active')
        .eq('id', productId)
        .single();

      if (error) {
        console.error('Error checking product update:', error);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Error in checkProductUpdate:', error);
      return null;
    }
  }

  /**
   * Check if a product exists and is accessible
   * This is even more lightweight - just checks existence
   */
  static async checkProductExists(productId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from('products')
        .select('id')
        .eq('id', productId)
        .single();

      return !error && !!data;
    } catch (error) {
      console.error('Error checking product existence:', error);
      return false;
    }
  }
}
